import React from 'react'

const IconPinPoint = props => (
  <svg width={24} height={24} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M.5 0h24v24H.5z" />
      <path
        d="M17.79 2.044a8.69 8.69 0 011.9 11.035l-.05.09-5.47 9.49a2.286 2.286 0 01-1.97 1.15 2.29 2.29 0 01-2-1.14l-5.51-9.59A8.69 8.69 0 0117.789 2.044zm-7.851.321A6.69 6.69 0 005.51 8.719c.014 1.214.36 2.4 1 3.43v.13l5.42 9.39c.032.107.13.18.24.18.112 0 .21-.073.24-.18l5.48-9.49a6.69 6.69 0 00-7.952-9.814zm3.55 3.224a3.379 3.379 0 012.081 3.13 3.369 3.369 0 01-3.37 3.37 3.38 3.38 0 111.289-6.5zM12.2 7.339a1.38 1.38 0 101.37 1.38A1.368 1.368 0 0012.2 7.34z"
        fill={props.fill}
        fillRule="nonzero"
      />
    </g>
  </svg>
)

export default IconPinPoint
